import type { AskHelixBriefsPublicBriefSpecDto } from './briefs-agent';

export const PROACTIVE_DELIVERY_PREFERENCES_SCHEMA_VERSION =
  'proactive_delivery_preferences_v1' as const;
export const PROACTIVE_DELIVERY_DIGEST_SCHEMA_VERSION = 'proactive_delivery_digest_v1' as const;

export const PROACTIVE_DELIVERY_WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const;

export type ProactiveDeliveryWeekday = (typeof PROACTIVE_DELIVERY_WEEKDAYS)[number];

export type ProactiveDeliveryPreferencesDto = Readonly<{
  schemaVersion: typeof PROACTIVE_DELIVERY_PREFERENCES_SCHEMA_VERSION;
  enabled: boolean;
  frequency: 'daily' | 'weekdays' | 'weekly';
  weeklyDay: ProactiveDeliveryWeekday | null;
  deliveryTimeLocal: string;
  timeZone: string;
  quietHours: Readonly<{
    startLocal: string;
    endLocal: string;
  }> | null;
}>;

export type ProactiveDeliveryPreferencesResponseDto = Readonly<{
  globalEnabled: boolean;
  configured: boolean;
  preferences: ProactiveDeliveryPreferencesDto | null;
}>;

export type ProactiveDeliveryDigestProvenanceDto = Readonly<{
  contextPackId: string;
  evidenceBundleId: string;
  briefConfigId: string | null;
  briefConfigVersion: string | null;
  evidenceRefIds: string[];
  decisionBindingIds: string[];
  decisionIds: string[];
  watchEventIds: string[];
  watchIds: string[];
  decisionConsoleAsOf: string;
}>;

export type ProactiveDeliveryInboxItemDto = Readonly<{
  schemaVersion: typeof PROACTIVE_DELIVERY_DIGEST_SCHEMA_VERSION;
  deliveryId: string;
  deliveredAt: string;
  localDeliveryDate: string;
  strategyId: string;
  briefSpec: AskHelixBriefsPublicBriefSpecDto;
  provenance: ProactiveDeliveryDigestProvenanceDto;
}>;

export type ProactiveDeliveryInboxResponseDto = Readonly<{
  items: ProactiveDeliveryInboxItemDto[];
}>;
